import React from 'react';
import styles from './CustomChips.module.css';

type CustomChipsProps = {
    children: string;
    backgroundColor: string;
}

const CustomChips = (props: CustomChipsProps) => {
    return (
        <div 
            className={styles.chips}
            style={{ backgroundColor: props.backgroundColor }}
        >
            <p>{props.children}</p>
        </div>
    )
}

export default CustomChips;